"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_ATTRIBUTE_NAMES = void 0;
const attributes_1 = require("../../constants/attributes");
/*
  Although these are supposed to be original fields,
  we still request the enriched ones because the original field names may vary from catalog to catalog
  (e.g., image_url, pictured_at_page, etc.).
  However, the name of the enriched field is consistent, so we query it instead, but display all values regardless of their validity.
*/
exports.BASE_ATTRIBUTE_NAMES = [
    attributes_1.PRODUCT_BRAND_LABEL,
    attributes_1.PRODUCT_DESCRIPTION_LABEL,
    attributes_1.PRODUCT_PAGE_URL_LABEL,
    attributes_1.PRODUCT_IMAGE_LABEL,
    attributes_1.PRODUCT_CATEGORIES_LABEL,
];
